"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
/**
 * Represents a deployed contract. Generates a Call per each request.
 * Call generation has a syntax similar to ethers.
 * @example
 * const daiContract = new Contract(daiAddress, erc20Abi);
 * daiContract.balanceOf(address); // returns a Call object
 */
class EthcallContract {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  /**
   * Create a contract.
   * @param address Address of the contract
   * @param abi ABI of the contract
   */
  constructor(address, abi) {
    (0, _defineProperty2.default)(this, "address", void 0);
    (0, _defineProperty2.default)(this, "abi", void 0);
    (0, _defineProperty2.default)(this, "functions", void 0);
    this.address = address;
    this.abi = abi;
    this.functions = abi.filter(x => x.type === 'function');
    const callFunctions = this.functions.filter(x => x.stateMutability === 'pure' || x.stateMutability === 'view');
    for (const callFunction of callFunctions) {
      const name = callFunction.name;
      if (!name) {
        continue;
      }
      const getCall = makeCallFunction(this, name);
      if (!this[name]) {
        Object.defineProperty(this, name, {
          enumerable: true,
          value: getCall,
          writable: false
        });
      }
    }
  }
}
function makeCallFunction(contract, name) {
  return (...params) => {
    const address = contract.address;
    const func = contract.functions.find(f => f.name === name);
    const inputs = (func === null || func === void 0 ? void 0 : func.inputs) || [];
    const outputs = (func === null || func === void 0 ? void 0 : func.outputs) || [];
    return {
      contract: {
        address
      },
      name,
      inputs,
      outputs,
      params
    };
  };
}
var _default = exports.default = EthcallContract;
//# sourceMappingURL=contract.js.map